import React from 'react'
import PropTypes from 'prop-types'
import {
  Wrapper,
  Text,
  Background,
  Indicator,
  GoalIndicator,
  GoalIndicatorWrapper,
  GoalText,
  PercentCompleteText,
} from './component.styles'

const ProgressBar = ({
  className,
  dataTestId,
  hideProgressText,
  goalPercentage,
  goalValue,
  notStartedText,
  percentComplete,
  isOnlyLeader,
}) => {
  const progressText =
    percentComplete === 0 ? notStartedText : `${percentComplete}% Complete`
  const showGoalIndicator = goalPercentage || goalValue
  if (isNaN(percentComplete)) {
    percentComplete = 0
  }
  const roundedPercentComplete = Math.ceil(percentComplete)
  const roundedGoalPercentage = Math.ceil(goalPercentage)

  return (
    <Wrapper className={className} dataTestId={dataTestId}>
      {!hideProgressText && (
        <Text
          className={`${className}-text`}
          dataTestId={`${dataTestId}-text`}
          id={`${dataTestId}-text`}
        >
          {progressText}
        </Text>
      )}
      <Background
        className={`${className}-background`}
        dataTestId={`${dataTestId}-background`}
        id={`${dataTestId}-background`}
      >
        <Indicator
          className={`${className}-indicator`}
          dataTestId={`${dataTestId}-indicator`}
          id={`${dataTestId}-indicator`}
          isOnlyLeader={isOnlyLeader}
          percentComplete={roundedPercentComplete}
        >
          {goalPercentage && (
            <PercentCompleteText percentComplete={roundedPercentComplete}>
              {roundedPercentComplete}%
            </PercentCompleteText>
          )}
        </Indicator>
        {showGoalIndicator && (
          <GoalIndicatorWrapper
            goalPercentage={roundedGoalPercentage}
            goalValue={goalValue}
          >
            <GoalIndicator />
            <GoalText
              goalValue={goalValue}
              percentComplete={roundedPercentComplete}
            >
              Goal: {goalValue || `${roundedGoalPercentage}%`}
            </GoalText>
          </GoalIndicatorWrapper>
        )}
      </Background>
    </Wrapper>
  )
}

ProgressBar.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  goalPercentage: PropTypes.number,
  goalValue: PropTypes.number,
  hideProgressText: PropTypes.bool,
  isOnlyLeader: PropTypes.bool,
  notStartedText: PropTypes.string,
  percentComplete: PropTypes.number,
}

ProgressBar.defaultProps = {
  dataTestId: 'sela-progressbar',
  notStartedText: 'Not Started',
  percentComplete: 0,
  isOnlyLeader: false,
}

export default ProgressBar
